import request from '../../../util/SuperagentUtils'

export const saveImageToS3Request = (image: File, correlationId: string) => {
  if (image) {
    return request
      .post(`/api/aws-rek`)
      .attach('file', image)
      .field('correlationId', correlationId)
  }
}
